import styled from "@emotion/styled";
import { Border, Button, Modal, Typography } from "@ibeckinc/ui-elements";
import { useRouter } from "next/router";
import React, { FunctionComponent, useCallback } from "react";

import { useMobile } from "../../hooks/useMobile";
import { pagesPath } from "../../lib/$path";
import { device } from "../../utils";

const { Text } = Typography;

type Contents = {
  heading: string;
  content: string;
};

const LeadingContents: Contents[] = [
  {
    heading: "厳選企業との成長機会",
    content:
      "外資系戦略ファーム・投資銀行・メーカー、日経トップ企業、スタートアップ企業の最新インターン、長期インターン・本選考情報等（一例：オルタナ限定外資本国での採用情報等掲載）　",
  },
  {
    heading: "内定者体験記",
    content:
      "質の高い情報を提供するために、ナビサイト唯一の内定者のみが選考体験記、就活体験記を掲載",
  },
  {
    heading: "限定イベントへの招待",
    content:
      "企業共催キャリアデザインセミナーやビジネススキル向上イベント等、ご自身のキャリアを実際のビジネスプロフェッショナルが機会提供致します。",
  },
  {
    heading: "選考会への参加が可能",
    content:
      "限定講座への参加は、選考会への参加が必須となります。オルタナ講師陣は15名以上。戦略コンサルファーム・投資銀行・IT・商社等の研修担当やマネジメント層が講座実施致します。",
  },
  {
    heading: "スカウト",
    content:
      "厳選した優良企業から、特別選考やイベント、面接などのスカウトが届きます。",
  },
  {
    heading: "ご自身の得たい情報・能力・キャリア志向性に応じたコンテンツ提供",
    content:
      "登録内容をより詳しく記載頂くことで、より適した情報提供が可能になります。",
  },
];

const PCHeadlines: string[] = [
  "本サイトは、外資系や日系トップ企業への就職・転職を",
  "目指す方対象のキャリアアップ支援サービスです。",
  "ご自身の志向性に合わせて、情報提供内容が変わりますので、まずはご登録ください。",
];
const SPHeadlines: string[] = [
  "本サイトは、外資系や日系トップ企業への",
  "就職・転職を目指す方対象の",
  "キャリアアップ支援サービスです。",
  "ご自身の志向性に合わせて、",
  "情報提供内容が変わりますので、",
  "まずはご登録ください。",
];

const RegistrationLeadingModal: FunctionComponent = ({}) => {
  const { isMobile } = useMobile();
  const router = useRouter();

  const handleClick = useCallback(() => {
    router.push(pagesPath.sign_up.$url());
  }, [router]);

  return (
    <_Modal open={true} width={isMobile() ? "auto" : "1000px"} height="auto">
      <ModalContent>
        <FlexBox direction="column">
          {isMobile()
            ? SPHeadlines.map((text, idx) => (
                <TopText
                  key={`sp-top-text-${idx}`}
                  multiline
                  alignment="center"
                  lineHeight="regular"
                >
                  {text}
                </TopText>
              ))
            : PCHeadlines.map((text, idx) => (
                <TopText
                  key={`web-top-text-${idx}`}
                  multiline
                  alignment="center"
                  lineHeight="regular"
                >
                  {text}
                </TopText>
              ))}
        </FlexBox>
        <_Button size="large" onClick={handleClick}>
          会員登録する
        </_Button>
        <FlexBox direction="row">
          {LeadingContents.map((content, idx) => {
            return (
              <ContentBox key={`conduction-content-${idx}`}>
                <Text bold="bold" size="big" multiline>
                  {content.heading}
                </Text>
                <SentenceText multiline size="big" lineHeight="regular">
                  {content.content}
                </SentenceText>
                <BlandLine />
              </ContentBox>
            );
          })}
        </FlexBox>
        {isMobile() && (
          <_Button size="large" onClick={handleClick}>
            会員登録する
          </_Button>
        )}
      </ModalContent>
    </_Modal>
  );
};

export default RegistrationLeadingModal;

const _Modal = styled(Modal)<{ width: string; height: string }>`
  ${({ width }) => `width: ${width};
  max-width: ${width};`}
  ${({ height }) => `height: ${height}`};

  @media ${device.pc} {
    margin: 0 auto;
  }

  @media ${device.mobile} {
    min-width: 336px;
    margin: 20px 20px;
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 766px;

  @media ${device.mobile} {
    height: auto;
  }
`;

const FlexBox = styled.div<{ direction: "row" | "column" }>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 311px;
  height: 208px;
  padding-top: 25px;
  margin: 0 14px 29px 14px;
  border-top: solid 1px;
  border-color: ${Border.Base};

  @media ${device.mobile} {
    margin: 0 0 29px 0;
  }
`;

const _Button = styled(Button)`
  margin: 38px 0 43px 0;
`;

const TopText = styled(Text)`
  @media ${device.mobile} {
    max-width: 304px;
  }
`;

const SentenceText = styled(Text)`
  margin-top: 22px;
  max-width: 267px;
  flex-grow: 2;
`;

const BlandLine = styled.div`
  height: 4px;
  width: 100%;
`;
